// extracted by mini-css-extract-plugin
module.exports = {"ul":"_2rgiT","li":"_187Iq","a":"_1kuiu","disabled":"_3GoWU","aActive":"_1lYtC","icon":"_3Ut1y"};